// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.oxGrid .k-detail-cell {
  padding: 0px !important;
}
.oxGrid .hideColumnHeaders .k-grid-header {
  display: none;
}
.oxGrid .alignLeft {
  justify-content: flex-start;
}
.oxGrid .k-hierarchy-cell .k-column-resizer {
  display: none;
}
.oxGrid .listActionIcons {
  width: 15px;
  text-align: center;
}
.oxGrid .k-toolbar {
  justify-content: space-between;
}
.oxGrid .k-toolbar:before {
  content: none;
}
.oxGrid .row-container-items,
.oxGrid .row-container-items figure {
  border-right-width: 1px;
}
.oxGrid .k-grid td {
  border-left-width: 1px !important;
}
.oxGrid .k-grid td {
  border-left-width: 1px !important;
}
.oxGrid .k-table-th,
.oxGrid .k-table-thead,
.oxGrid .k-grid-toolbar,
.oxGrid .k-checkbox-white,
.oxGrid .k-grid-pager {
  background-color: #fff !important;
}
.oxGrid .k-grid tr.k-alt {
  background-color: transparent !important;
}
.oxGrid td.k-table-td {
  outline: 0.5px solid #f8f9fa !important;
}
.oxGrid .k-table-td {
  border-color: #fff !important;
}
.oxGrid .k-table-thead {
  font-weight: bold;
}
.oxGrid .k-grid-btn-outline {
  border: 1px solid rgba(0, 0, 0, 0.1607843137) !important;
  color: #424242 !important;
  background-color: #fff !important;
}
.oxGrid .k-grid-btn-outline:hover {
  border: 2px solid rgba(0, 0, 0, 0.1607843137) !important;
  color: #424242 !important;
  background-color: #fff !important;
}
.oxGrid .btn {
  outline: none;
  border: 0px;
}
.oxGrid .k-hierarchy-cell .k-svg-icon.k-svg-i-minus svg path {
  d: path("M256 352 128 160h256L256 352z");
}
.oxGrid {
  /* Expand (currently collapsed) shows a right-caret ▶ */
}
.oxGrid .k-hierarchy-cell .k-svg-icon.k-svg-i-plus svg path {
  d: path("M352 256 160 384V128l192 128z");
}
.oxGrid .inlineWithTitle {
  border: 1px solid #b8bfc1;
  padding: 4px 15px;
  font-size: 12px;
  border-radius: 15px;
  margin: 4px;
}
.oxGrid .inlineWithTitle .k-button-text {
  display: flex;
  gap: 5px;
  align-items: center;
}

.grid-filter-toolbar {
  border-bottom-width: 0px !important;
}

.k-grid-filter-container {
  width: 100%;
}
.k-grid-filter-container .k-grid-custom-search {
  position: relative;
  width: 28em;
  height: 35px;
}
.k-grid-filter-container .k-grid-custom-search .grid-search-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: #828282;
  z-index: 1;
  font-size: 16px;
}
.k-grid-filter-container .k-grid-custom-search .grid-serach-input {
  width: 100%;
  height: 100%;
  padding-left: 38px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}
.k-grid-filter-container .k-grid-custom-search .grid-serach-input::placeholder {
  color: #828282;
  opacity: 1;
}
.k-grid-filter-container .k-grid-custom-search .grid-serach-input:focus {
  outline: none;
  box-shadow: none;
}
.k-grid-filter-container .grid-filter-count {
  position: absolute;
  top: -7px;
  right: -11px;
  background-color: red;
  color: white;
  border-radius: 40%;
  padding: 2px 7px;
  font-size: 12px;
  font-weight: bold;
}
.k-grid-filter-container .grid-filter-button {
  height: 35px;
  margin: 0px 10px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  color: #828282;
  background-color: transparent;
  cursor: pointer;
  padding: 0px 15px;
  position: relative;
}
.k-grid-filter-container .grid-filter-button:focus {
  outline: none;
  box-shadow: none;
}
.k-grid-filter-container .grid-filter-button:hover {
  background-color: #ffffff;
  border-color: #e0e0e0;
  color: #828282;
}
.k-grid-filter-container .grid-filter-button .k-button-text {
  display: flex;
  align-items: center;
}
.k-grid-filter-container .grid-filter-icon {
  color: #828282;
  margin-right: 10px;
  font-size: 16px;
}

.filter-builder-modal .k-dialog {
  border-radius: 20px;
  border-color: #e9ebec;
}
.filter-builder-modal .k-dialog .filter-builder-container {
  margin: 12px;
  width: 50vw;
}
.filter-builder-modal .k-dialog .filter-builder-container .close-icon {
  width: 18px;
  height: 18px;
  display: flex;
  font-size: 18px;
  cursor: pointer;
  margin-left: auto;
  color: #7e8a8d;
  justify-content: end;
}
.filter-builder-modal .k-dialog .filter-builder-container .filter-builder-btns {
  display: flex;
  justify-content: end;
  gap: 15px;
  margin-bottom: 15px;
}
.filter-builder-modal .k-dialog .filter-builder-container .filter-builder-btns .apply-btn {
  border-radius: 25px;
  padding: 6px 20px;
  color: #ffffff !important;
  font-weight: 600;
  background-color: #2f80ed !important;
}
.filter-builder-modal .k-dialog .filter-builder-container .filter-builder-btns .apply-btn:focus {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}
.filter-builder-modal .k-dialog .filter-builder-container .filter-builder-btns .apply-btn:hover {
  background-color: #2f80ed !important;
  border: none !important;
}

.actionButtonsHover {
  position: fixed;
}
.actionButtonsHover .actionsContainer {
  z-index: 10 !important;
  display: flex;
  flex-direction: column;
}
.actionButtonsHover .actionsContainer .visibleButtons {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.actionButtonsHover .actionsContainer .hoverButtons {
  flex-wrap: nowrap;
}
.actionButtonsHover .actionsContainer .alignRight {
  justify-content: flex-end;
}
.actionButtonsHover .actionsContainer .btn {
  font-size: 0.9rem !important;
}

.glass-effect {
  background-color: rgba(255, 255, 255, 0.35) !important;
  border-radius: 8px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.35) !important;
  backdrop-filter: blur(5px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.hiddenButtons {
  margin: 4px 0px !important;
}
.hiddenButtons .k-button .k-button-text {
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 10px;
}

.oxGrid_columnMenu .k-animation-container-relative {
  display: block;
}
.oxGrid_columnMenu .k-link {
  color: #3d3c3c !important;
}
.oxGrid_columnMenu .k-tabstrip-item.k-active .k-link {
  color: inherit !important;
}
.oxGrid_columnMenu .k-child-animation-container {
  padding: 4px;
  max-height: 250px;
  overflow-y: scroll;
}
.oxGrid_columnMenu .k-child-animation-container .k-popup .k-multicheck-wrap {
  max-height: none;
}
.oxGrid_columnMenu .k-child-animation-container .k-filter-menu .k-filter-menu-container .k-searchbox {
  display: none;
}
.oxGrid_columnMenu .k-child-animation-container .k-filter-menu .k-item .k-checkbox-label {
  color: #3d3c3c;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/Grid/OX_GridStyles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACd;EACE,uBAAA;AACJ;AAEI;EACE,aAAA;AAAN;AAGE;EACE,2BAAA;AADJ;AAII;EACE,aAAA;AAFN;AAKE;EACE,WAAA;EACA,kBAAA;AAHJ;AAME;EACE,8BAAA;AAJJ;AAKI;EACE,aAAA;AAHN;AAOE;;EAEE,uBAAA;AALJ;AAOE;EACE,iCAAA;AALJ;AAQE;EACE,iCAAA;AANJ;AAWE;;;;;EAKE,iCAAA;AATJ;AAYE;EACE,wCAAA;AAVJ;AAaE;EACE,uCAAA;AAXJ;AAcE;EACE,6BAAA;AAZJ;AAeE;EACE,iBAAA;AAbJ;AAgBE;EACE,wDAAA;EACA,yBAAA;EACA,iCAAA;AAdJ;AAiBE;EACE,wDAAA;EACA,yBAAA;EACA,iCAAA;AAfJ;AAoBE;EACE,aAAA;EACA,WAAA;AAlBJ;AAoBE;EACE,wCAAA;AAlBJ;AApEA;EAyFE,uDAAA;AAlBF;AAmBE;EACE,wCAAA;AAjBJ;AAoBE;EACE,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAlBJ;AAmBI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAjBN;;AAsBA;EACE,mCAAA;AAnBF;;AAsBA;EAGE,WAAA;AArBF;AAuBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AArBJ;AAuBI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;AArBN;AAwBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAtBN;AAwBM;EACE,cAAA;EACA,UAAA;AAtBR;AAyBM;EACE,aAAA;EACA,gBAAA;AAvBR;AA4BE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA1BJ;AA6BE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA3BJ;AA6BI;EACE,aAAA;EACA,gBAAA;AA3BN;AA8BI;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AA5BN;AA+BI;EACE,aAAA;EACA,mBAAA;AA7BN;AAiCE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AA/BJ;;AAoCE;EACE,mBAAA;EACA,qBAAA;AAjCJ;AAmCI;EACE,YAAA;EACA,WAAA;AAjCN;AAmCM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;AAjCR;AAoCM;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AAlCR;AAoCQ;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oCAAA;AAlCV;AAoCU;EACE,wBAAA;EACA,2BAAA;EACA,uBAAA;AAlCZ;AAqCU;EACE,oCAAA;EACA,uBAAA;AAnCZ;;AA2CA;EACE,eAAA;AAxCF;AAyCE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;AAvCJ;AAwCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAtCN;AAwCI;EACE,iBAAA;AAtCN;AAwCI;EACE,yBAAA;AAtCN;AAwCI;EACE,4BAAA;AAtCN;;AA2CA;EACE,sDAAA;EACA,kBAAA;EACA,qDAAA;EACA,qCAAA;EACA,qDAAA;AAxCF;;AA0CA;EACE,0BAAA;AAvCF;AAyCI;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAvCN;;AA4CE;EACE,cAAA;AAzCJ;AA2CE;EACE,yBAAA;AAzCJ;AA4CI;EACE,yBAAA;AA1CN;AA6CE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;AA3CJ;AA4CI;EACE,gBAAA;AA1CN;AA8CQ;EACE,aAAA;AA5CV;AAgDQ;EACE,cAAA;AA9CV","sourcesContent":[".oxGrid {\n  .k-detail-cell {\n    padding: 0px !important;\n  }\n  .hideColumnHeaders {\n    .k-grid-header {\n      display: none;\n    }\n  }\n  .alignLeft {\n    justify-content: flex-start;\n  }\n  .k-hierarchy-cell {\n    .k-column-resizer {\n      display: none;\n    }\n  }\n  .listActionIcons {\n    width: 15px;\n    text-align: center;\n  }\n\n  .k-toolbar {\n    justify-content: space-between;\n    &:before {\n      content: none;\n    }\n  }\n\n  .row-container-items,\n  .row-container-items figure {\n    border-right-width: 1px;\n  }\n  .k-grid td {\n    border-left-width: 1px !important;\n  }\n\n  .k-grid td {\n    border-left-width: 1px !important;\n  }\n\n  //new OX_Grid styling\n\n  .k-table-th,\n  .k-table-thead,\n  .k-grid-toolbar,\n  .k-checkbox-white,\n  .k-grid-pager {\n    background-color: #fff !important;\n  }\n\n  .k-grid tr.k-alt {\n    background-color: transparent !important;\n  }\n\n  td.k-table-td {\n    outline: 0.5px solid #f8f9fa !important;\n  }\n\n  .k-table-td {\n    border-color: #fff !important;\n  }\n\n  .k-table-thead {\n    font-weight: bold;\n  }\n\n  .k-grid-btn-outline {\n    border: 1px solid #00000029 !important;\n    color: #424242 !important;\n    background-color: #fff !important;\n  }\n\n  .k-grid-btn-outline:hover {\n    border: 2px solid #00000029 !important;\n    color: #424242 !important;\n    background-color: #fff !important;\n  }\n  .actionButtonColumn {\n    // display: none;\n  }\n  .btn {\n    outline: none;\n    border: 0px;\n  }\n  .k-hierarchy-cell .k-svg-icon.k-svg-i-minus svg path {\n    d: path(\"M256 352 128 160h256L256 352z\");\n  }\n\n  /* Expand (currently collapsed) shows a right-caret ▶ */\n  .k-hierarchy-cell .k-svg-icon.k-svg-i-plus svg path {\n    d: path(\"M352 256 160 384V128l192 128z\");\n  }\n\n  .inlineWithTitle {\n    border: 1px solid #b8bfc1;\n    padding: 4px 15px;\n    font-size: 12px;\n    border-radius: 15px;\n    margin: 4px;\n    .k-button-text {\n      display: flex;\n      gap: 5px;\n      align-items: center;\n    }\n  }\n}\n\n.grid-filter-toolbar {\n  border-bottom-width: 0px !important;\n}\n\n.k-grid-filter-container {\n  // padding: 10px 0px !important;\n  // background-color: #ffffff !important;\n  width: 100%;\n\n  .k-grid-custom-search {\n    position: relative;\n    width: 28em;\n    height: 35px;\n\n    .grid-search-icon {\n      position: absolute;\n      top: 50%;\n      left: 12px;\n      transform: translateY(-50%);\n      color: #828282;\n      z-index: 1;\n      font-size: 16px;\n    }\n\n    .grid-serach-input {\n      width: 100%;\n      height: 100%;\n      padding-left: 38px;\n      border-radius: 8px;\n      border: 1px solid #e0e0e0;\n\n      &::placeholder {\n        color: #828282;\n        opacity: 1;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: none;\n      }\n    }\n  }\n\n  .grid-filter-count {\n    position: absolute;\n    top: -7px;\n    right: -11px;\n    background-color: red;\n    color: white;\n    border-radius: 40%;\n    padding: 2px 7px;\n    font-size: 12px;\n    font-weight: bold;\n  }\n\n  .grid-filter-button {\n    height: 35px;\n    margin: 0px 10px;\n    border-radius: 8px;\n    border: 1px solid #e0e0e0;\n    color: #828282;\n    background-color: transparent;\n    cursor: pointer;\n    padding: 0px 15px;\n    position: relative;\n\n    &:focus {\n      outline: none;\n      box-shadow: none;\n    }\n\n    &:hover {\n      background-color: #ffffff;\n      border-color: #e0e0e0;\n      color: #828282;\n    }\n\n    .k-button-text {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .grid-filter-icon {\n    color: #828282;\n    margin-right: 10px;\n    font-size: 16px;\n  }\n}\n\n.filter-builder-modal {\n  .k-dialog {\n    border-radius: 20px;\n    border-color: #e9ebec;\n\n    .filter-builder-container {\n      margin: 12px;\n      width: 50vw;\n\n      .close-icon {\n        width: 18px;\n        height: 18px;\n        display: flex;\n        font-size: 18px;\n        cursor: pointer;\n        margin-left: auto;\n        color: #7e8a8d;\n        justify-content: end;\n      }\n\n      .filter-builder-btns {\n        display: flex;\n        justify-content: end;\n        gap: 15px;\n        margin-bottom: 15px;\n\n        .apply-btn {\n          border-radius: 25px;\n          padding: 6px 20px;\n          color: #ffffff !important;\n          font-weight: 600;\n          background-color: #2f80ed !important;\n\n          &:focus {\n            outline: none !important;\n            box-shadow: none !important;\n            border: none !important;\n          }\n\n          &:hover {\n            background-color: #2f80ed !important;\n            border: none !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n.actionButtonsHover {\n  position: fixed;\n  .actionsContainer {\n    z-index: 10 !important;\n    display: flex;\n    flex-direction: column;\n    .visibleButtons {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-wrap: wrap;\n    }\n    .hoverButtons {\n      flex-wrap: nowrap;\n    }\n    .alignRight {\n      justify-content: flex-end;\n    }\n    .btn {\n      font-size: 0.9rem !important;\n    }\n  }\n}\n\n.glass-effect {\n  background-color: rgba(255, 255, 255, 0.35) !important;\n  border-radius: 8px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.35) !important;\n  backdrop-filter: blur(5px) !important;\n  border: 1px solid rgba(255, 255, 255, 0.3) !important;\n}\n.hiddenButtons {\n  margin: 4px 0px !important;\n  .k-button {\n    .k-button-text {\n      font-size: 0.9rem;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n}\n.oxGrid_columnMenu {\n  .k-animation-container-relative {\n    display: block;\n  }\n  .k-link {\n    color: #3d3c3c !important; //unselected tab color\n  }\n  .k-tabstrip-item.k-active {\n    .k-link {\n      color: inherit !important; //selected tab color\n    }\n  }\n  .k-child-animation-container {\n    padding: 4px;\n    max-height: 250px;\n    overflow-y: scroll;\n    .k-popup .k-multicheck-wrap {\n      max-height: none;\n    }\n    .k-filter-menu {\n      .k-filter-menu-container {\n        .k-searchbox {\n          display: none;\n        }\n      }\n      .k-item {\n        .k-checkbox-label {\n          color: #3d3c3c;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
